import { Pipe, PipeTransform } from '@angular/core';

import { ICoverage } from '@amfam/policy/models';

@Pipe({
  name: 'transformcoverages',
  standalone: false
})
export class TransformCoveragesPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(coverages: ICoverage[], _config?: { [key: string]: object }): ICoverage[] {
    const c = coverages
      .filter(coverage => coverage.publicID !== 'PALeaseLoanCov_af')
      .map(coverage => ({ ...this.handleDeductibleState(coverage) }));
    return c;
  }

  handleDeductibleState(coverage: ICoverage) {
    if (coverage.publicID === 'PAUmpdCov_af') {
      const perAccidentTerm = coverage.terms.find(t => t.publicID === 'PAUmpdLimit_af');
      const deductibleTerm = coverage.terms.find(t => t.publicID === 'PAUmpdDed_af');

      if (perAccidentTerm?.chosenTermValue?.toString()?.toLowerCase() === 'rejected') {
        const noCoverageOption = deductibleTerm.options.find(o => o.name === 'No Coverage');
        return {
          ...coverage,
          terms: coverage.terms.map(t => ({
            ...t,
            disabled: deductibleTerm.publicID === t.publicID ? true : false,
            chosenTerm:
              deductibleTerm.publicID === t.publicID ? noCoverageOption.code : t.chosenTerm,
            chosenTermValue:
              deductibleTerm.publicID === t.publicID ? noCoverageOption.name : t.chosenTermValue
          }))
        };
      } else if (deductibleTerm) {
        const validCoverageOption = deductibleTerm.options.find(o => o.name !== 'No Coverage');
        return {
          ...coverage,
          terms: coverage.terms.map(t => ({
            ...t,
            chosenTerm:
              deductibleTerm.publicID === t.publicID ? validCoverageOption.code : t.chosenTerm,
            chosenTermValue:
              deductibleTerm.publicID === t.publicID ? validCoverageOption.name : t.chosenTermValue
          }))
        };
      }
    }
    return { ...coverage };
  }
}
